/**
 * File kinds we render through the ``doppler://`` URI resolver.
 *
 * Replaces the inline ``"pdf" | "excel"`` literal union in
 * ``utils/dopplerUri.ts`` flagged in PR review. The two ``EXCEL``
 * variants distinguish source workbooks (uploaded by the user) from
 * modified-workbook artifacts produced by the ``manipulate_workbook``
 * tool — they resolve through different chat-scoped endpoints, so
 * downstream consumers branch on this discriminator.
 */

export const FileType = {
	PDF: "pdf",
	EXCEL: "excel",
	/** A citation ANCHOR. Identifies an evidence event and nothing else: it
	 * names no file and resolves to no URL, because its whole job is to put the
	 * corresponding citation card into the audit trail. Navigation lives on the
	 * card. */
	CITE: "cite",
	/** A plain document opened as-is — today, the markdown projection an email
	 * thread or Slack channel was ingested into. It has no in-app viewer, so it
	 * resolves to a signed URL and opens in a new tab. */
	DOC: "doc",
} as const;
export type FileType = (typeof FileType)[keyof typeof FileType];

/** Distinguishes a source file from a derived (chat-scoped) artifact. */
export const FileSubkind = {
	FILE: "file",
	ARTIFACT: "artifact",
} as const;
export type FileSubkind = (typeof FileSubkind)[keyof typeof FileSubkind];
